const e = {
  name: "ArrowTop",
  dimensions: { width: 16, height: 20 },
  content: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.2929 8.70711C14.6834 9.09763 15.3166 9.09763 15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289L8.70782 0.293606C8.70541 0.29119 8.70298 0.288787 8.70055 0.286395C8.52079 0.109902 8.27463 0.000801696 8.003 4.33622e-06L8 0L7.997 4.33502e-06C7.8625 0.00039928 7.73425 0.027346 7.61722 0.0758786C7.49927 0.124678 7.38877 0.197017 7.29289 0.292893L0.292894 7.29289C-0.0976312 7.68342 -0.0976312 8.31658 0.292894 8.70711C0.683418 9.09763 1.31658 9.09763 1.70711 8.70711L7 3.41421L7 19C7 19.5523 7.44772 20 8 20C8.55229 20 9 19.5523 9 19L9 3.41421L14.2929 8.70711Z" fill="currentColor"/>
  `
};
export {
  e as ArrowTop
};
